import * as Factory from 'factory.ts'
import faker from 'faker'

import { ApproverApiModelStub } from '@webapp/core/data-access/api-models/stubs/ApproverApiModel.stub'
import { type CostDetails } from '@webapp/models'
import { OrderStatuses } from '@webapp/models/enums/OrderStatus'
import { type Order, type OrderV2 } from '@webapp/models/Order'
import { CurrencyMock } from './currency.factory'
import { DepartmentMock } from './department.factory'
import { LocationMock } from './location.factory'
import { RecurringOrderItemMock } from './orderItem.factory'
import { UserMock } from './user.factory'

export const CostDetailsMock = Factory.Sync.makeFactory<CostDetails>({
  tax_amount: Factory.each(() => parseFloat(faker.finance.amount())),
  subtotal: Factory.each(() => parseFloat(faker.finance.amount())),
  total_cost: Factory.each(() => parseFloat(faker.finance.amount())),
  total_cost_in_base_currency: Factory.each(() =>
    parseFloat(faker.finance.amount())
  ),
})

export const OrderMock = Factory.Sync.makeFactory<Order>({
  num: faker.random.number(),
  order_number: faker.random.number(),
  date: faker.date.past(10).toISOString(),
  description: faker.lorem.paragraphs(),
  item_count: faker.random.number(),
  punchout_group: faker.random.number(),
  total_cost: faker.random.number(),
  user_name: faker.name.findName(),
  user: Factory.each(() => UserMock.build()),
  uuid: faker.random.uuid(),
  department: DepartmentMock.build(),
  order_items: RecurringOrderItemMock.buildList(1),
})

export const PunchOutOrderMock = OrderMock.extend({
  punchout_supplier_name: Factory.each(
    () => `Order supplier ${faker.random.word()}`
  ),
  punchout_supplier_icon: Factory.each(() => faker.internet.url()),
})

export const OrderV2Mock = Factory.Sync.makeFactory<OrderV2>({
  num: faker.random.number(),
  order_number: faker.random.number(),
  date: faker.date.past(10).toISOString(),
  description: faker.commerce.productName(),
  item_count: faker.random.number(),
  punchout_group: faker.random.number(),
  totalPrice: faker.random.number().toString(),
  user: Factory.each(() => UserMock.build()),
  uuid: faker.random.uuid(),
  department: DepartmentMock.build(),
  approval_delegatee: null,
  approval_workflow: Factory.each(() => ({
    is_complete: false,
    current_step: {
      approver: {
        approvers: ApproverApiModelStub.buildList(1),
        is_pooled: false,
        level: faker.random.number({ min: 1, max: 5 }),
        group_id: faker.random.number(),
        group_name: faker.company.companyName(),
      },
      group_id: faker.random.number(),
      group_name: faker.company.companyName(),
    },
  })),
  branch: LocationMock.build(),
  currency: CurrencyMock.build(),
  dateModified: faker.date.past(10).toISOString(),
  dateRequired: faker.date.future(10).toISOString(),
  ip_address: null,
  lineCount: faker.random.number(),
  logs: [],
  next_approver: UserMock.build(),
  purchasedCount: 0,
  status: OrderStatuses.PENDING,
  total_cost_in_base_currency: faker.random.number(),
})
